// src/router/index.js
import Vue from 'vue';
import Router from 'vue-router';
import ZYTLXC from '@/components/zytlxc.vue';
import ZYTLGZ from '@/components/zytlgz.vue';
import LZTL from '@/components/lztl.vue';
import YATLXC from '@/components/yatlxc.vue';
import YATLGZ from '@/components/yatlgz.vue';
import HHTLXC from '@/components/hhtlxc.vue';
import HHTLGZ from '@/components/hhtlgz.vue';
import BSTLXZ from '@/components/bstlxc.vue';
import BSTLGZ from '@/components/bstlgz.vue';
import YLTLXX from '@/components/yltlxx.vue';
import ZTTLGZ from '@/components/zttlgz.vue';
import GYTLXC from '@/components/gytlxc.vue';
import GYTLGZ from '@/components/gytlgz.vue';
import TRWSTLXX from '@/components/trwstlxx.vue';
import ZKTLXCXX from '@/components/zktlxcxx.vue';
import ZKTLGZ from '@/components/zktlgz.vue';

Vue.use(Router);

export default new Router({
    mode: 'history', // 使用 HTML5 History 模式（可选：'hash' | 'history'）
    routes: [
        {
            path: '/zytlxc',
            name: 'zytlxc',
            component: ZYTLXC
        },
        {
            path: '/zytlgz',
            name: 'zytlgz',
            component: ZYTLGZ
        },
        {
            path: '/lztl',
            name: 'lztl',
            component: LZTL
        },
        {
            path: '/yatlxc',
            name: 'yatlxc',
            component: YATLXC
        },
        {
            path: '/yatlgz',
            name: 'yatlgz',
            component: YATLGZ
        },
        {
            path: '/hhtlxc',
            name: 'hhtlxc',
            component: HHTLXC
        },
        {
            path: '/hhtlgz',
            name: 'hhtlgz',
            component: HHTLGZ
        },
        {
            path: '/bstlxc',
            name: 'bstlxc',
            component: BSTLXZ
        },
        {
            path: '/bstlgz',
            name: 'bstlgz',
            component: BSTLGZ
        },
        {
            path: '/yltlxx',
            name: 'yltlxx',
            component: YLTLXX
        },
        {
            path: '/zttlgz',
            name: 'zttlgz',
            component: ZTTLGZ
        },
        {
            path: '/gytlxc',
            name: 'gytlxc',
            component: GYTLXC
        },
        {
            path: '/gytlgz',
            name: 'gytlgz',
            component: GYTLGZ
        },
        {
            path: '/trwstlxx',
            name: 'trwstlxx',
            component: TRWSTLXX
        },
        {
            path: '/zktlxcxx',
            name: 'zktlxcxx',
            component: ZKTLXCXX
        },
        {
            path: '/zktlgz',
            name: 'zktlgz',
            component: ZKTLGZ
        }
    ]
});
